import React, { useState, useCallback } from 'react';

import { ReactComponent as Logo } from '../../assets/icons/logo.svg';

const Header = () => {
  const [isNavVisible, setNavVisible] = useState(false);
  const toggleNav = useCallback(() => { setNavVisible(!isNavVisible); }, [isNavVisible]);

  return (
  <>
    <nav className="top" id="mainNavigation">
      <div className="nav-container">
        <a href="/">
          <Logo className='logo' />
        </a>

        <ul className="desktop-nav">
          <li className="nav-item">
            <a href="https://polygraph.net/usecases">Use Cases</a>
          </li>
          <li className="nav-item">
            <a href="https://polygraph.net/how-it-works">How it works</a>
          </li>
          <li className="nav-item">
            <a href="https://polygraph.net/pricing">Pricing</a>
          </li>
          <li className="nav-item">
            <a href="https://polygraph.net/articles">Articles</a>
          </li>
        </ul>

        <div className="right">
          <a href="/">Log In</a>
          <a href="/signup" className="button primary no-arrow hide-mobile">Sign Up</a>

          <div className="hamburger" onClick={toggleNav}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>
      </div>
      <div className="mirror one"></div>
      <div className="mirror two"></div>
    </nav>

    <nav id="mobileNavigation" className={'mobile-nav' + (isNavVisible ? " active" : "")}>
      <ul className="stagger">
        <li className="nav-item fade-in-right">
          <a href="https://polygraph.net/usecases">Use Cases</a>
        </li>
        <li className="nav-item fade-in-right">
          <a href="https://polygraph.net/how-it-works">How it works</a>
        </li>
        <li className="nav-item fade-in-right">
          <a href="https://polygraph.net/pricing">Pricing</a>
        </li>
        <li className="nav-item fade-in-right">
          <a href="https://polygraph.net/articles">Articles</a>
        </li>
        <li className="nav-item fade-in-right add-margin-bottom">
          <a href="https://dashboard.polygraph.net/login"
             target="_blank"
             rel="noopener noreferrer">Log In</a>
        </li>
        <li className="nav-item fade-in-right">
          <a href="https://polygraph.net/contact-us" className="button primary">Contact Us</a>
        </li>
      </ul>
    </nav>
  </>
  );
}

export default Header;
